// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contractPaymentEntity from './entities/contract-payment.json';
import contractPaymentMenu from '../pages/contract-payment/menu.json';
import contractPaymentFullForm from '../pages/contract-payment/forms/full.json';
import contractPaymentContextForm from '../pages/contract-payment/forms/context.json';
import contractPaymentMiniForm from '../pages/contract-payment/forms/mini.json';
import contractPaymentLookupForm from '../pages/contract-payment/forms/lookup.json';
import contractPaymentTableView from '../pages/contract-payment/views/table.json';
import contractPaymentCardsView from '../pages/contract-payment/views/cards.json';
import contractPaymentCalendarView from '../pages/contract-payment/views/calendar.json';
import contractPaymentDashboardView from '../pages/contract-payment/views/dashboard.json';

/** Тип запису «Платіж» зі сторінками пакета: меню, форми та подання з pages/contract-payment/. */
export const contractPaymentDefinition: IRecordTypeDefinition = {
  ...contractPaymentEntity,
  views: assembleViewSet({
      table: contractPaymentTableView,
      cards: contractPaymentCardsView,
      calendar: contractPaymentCalendarView,
      dashboard: contractPaymentDashboardView,
  }),
  form: contractPaymentFullForm,
  forms: { full: contractPaymentFullForm, context: contractPaymentContextForm, mini: contractPaymentMiniForm, lookup: contractPaymentLookupForm },
  menu: contractPaymentMenu,
} as IRecordTypeDefinition;
